import React, { useState } from 'react';
import { ArrowUpRightIcon, BellIcon, CheckCircle2Icon, Clock3Icon, MessageSquareTextIcon, PackageCheckIcon, SettingsIcon, TriangleAlertIcon } from 'lucide-react';
import { peakWaitData } from '../lib/platformData';
type MerchantDashboardProps = {
  onExit: () => void;
};
export function MerchantDashboard({
  onExit
}: MerchantDashboardProps) {
  const [selectedReview, setSelectedReview] = useState(false);
  return <main className="min-h-[calc(100vh-4rem)] bg-[#F4F7F4]" data-id="element-282" data-mp="2ssp0v8amb3mo">
      <div className="mx-auto w-full lg:grid lg:grid-cols-[244px_minmax(0,1fr)]" data-id="element-283" data-mp="2nu42zfiu8w1e">
        <aside className="bg-[#008F82] px-5 py-6 text-white lg:min-h-[calc(100vh-4rem)]" data-id="element-284" data-mp="32iqqw5mj6w48">
          <div className="border-b border-white/15 pb-5" data-id="element-285" data-mp="2xrs9f2pt3rze">
            <p className="text-xs font-bold uppercase tracking-[0.14em] text-[#E7B158]" data-id="element-286" data-mp="2xq7cx7jxlyyw">
              Pharmacy Pulse for business
            </p>
            <p className="mt-2 font-black" data-id="element-287" data-mp="253cwclq8jjqp">Northridge Family Pharmacy</p>
            <span className="mt-2 inline-flex items-center gap-1.5 text-xs text-[#C9D8CF]" data-id="element-288" data-mp="2510es9oe3be6">
              <CheckCircle2Icon className="h-3.5 w-3.5" data-id="element-289" data-mp="1433bynxsei5r" /> Verified owner
            </span>
          </div>
          <nav className="mt-5 flex gap-2 overflow-x-auto lg:flex-col" aria-label="Merchant navigation" data-id="element-290" data-mp="191xvxt7hqcrg">
            {[['Overview', PackageCheckIcon], ['Patient signals', MessageSquareTextIcon], ['Wait time', Clock3Icon], ['Settings', SettingsIcon]].map(([label, Icon]) => {
            const NavIcon = Icon as typeof PackageCheckIcon;
            return <button key={label as string} type="button" className={`inline-flex shrink-0 items-center gap-3 px-3 py-3 text-left text-sm font-bold ${label as string === 'Overview' ? 'bg-white/10 text-white' : 'text-[#C9D8CF] hover:bg-white/5 hover:text-white'}`} data-id="element-291" data-mp="u5gnpaulle94">
                  <NavIcon className="h-4 w-4" data-id="element-292" data-mp="aiqo285hgi7a" />
                  {label as string}
                </button>;
          })}
          </nav>
          <button type="button" onClick={onExit} className="mt-8 text-sm font-bold text-[#E7B158] underline underline-offset-4" data-id="element-293" data-mp="6gvnx6zagav3">
            View public profile
          </button>
        </aside>
        <section className="px-6 py-8 md:px-12 lg:px-16" data-id="element-294" data-mp="3nxwszc6c38t1">
          <div className="flex flex-wrap items-start justify-between gap-4" data-id="element-295" data-mp="3nyg7eiwrzf2b">
            <div data-id="element-296" data-mp="3izv76jhiwvdv">
              <p className="text-xs font-bold uppercase tracking-[0.14em] text-[#008F82]" data-id="element-297" data-mp="3j0etece7i5xp">
                Operations scorecard
              </p>
              <h1 className="mt-2 text-3xl font-black tracking-tight text-[#1C1C1C]" data-id="element-298" data-mp="3sx9pkon0bu8t">
                Good morning, Ana.
              </h1>
              <p className="mt-2 text-sm text-[#686868]" data-id="element-299" data-mp="35649c8d5mzxz">
                Here is how your patients experienced Northridge this week.
              </p>
            </div>
            <button type="button" className="inline-flex items-center gap-2 border border-[#C8D6CC] bg-white px-4 py-2.5 text-sm font-bold text-[#008F82] hover:bg-[#F4F7F4] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#008F82]" data-id="element-300" data-mp="1fprxr48cfy85">
              <BellIcon className="h-4 w-4" data-id="element-301" data-mp="1aqxczwqtfzle" /> 2 new signals
            </button>
          </div>
          <div className="mt-7 grid gap-4 lg:grid-cols-3" data-id="element-302" data-mp="1yh18fgtuot1b">
            <article className="border border-[#D7E2D9] bg-white p-5" data-id="element-303" data-mp="1yhko0qw135c6">
              <div className="flex items-start justify-between" data-id="element-304" data-mp="23et6ytp03deh">
                <div data-id="element-305" data-mp="1pgd2l9em1yzi">
                  <p className="text-xs font-bold uppercase tracking-[0.12em] text-[#008F82]" data-id="element-306" data-mp="1pgwdw79r9p4k">
                    Stock confidence
                  </p>
                  <p className="mt-3 text-4xl font-black tracking-tight text-[#1C1C1C]" data-id="element-307" data-mp="1uh0v5zihmnvu">
                    92%
                  </p>
                </div>
                <PackageCheckIcon className="h-5 w-5 text-[#008F82]" data-id="element-308" data-mp="j0snjjo78mdb" />
              </div>
              <p className="mt-5 text-sm font-bold text-[#008F82]" data-id="element-309" data-mp="yapmnukdf6mf">
                <ArrowUpRightIcon className="mr-1 inline h-4 w-4" data-id="element-310" data-mp="tj7mv9u33c31" />
                +3% this week
              </p>
              <p className="mt-2 text-xs text-[#777]" data-id="element-311" data-mp="ojcs2v76u2cp">
                2 reports mention a refill transfer.
              </p>
            </article>
            <article className="rounded-lg border border-gray-100 bg-white p-5" data-id="element-312" data-mp="kk41fz7g2kld">
              <div className="flex items-start justify-between" data-id="element-313" data-mp="1h78mft9abi6b">
                <div data-id="element-314" data-mp="1c8xhnwxujxuy">
                  <p className="text-xs font-bold uppercase tracking-[0.12em] text-[#B46423]" data-id="element-315" data-mp="1caqnxb4jsg2f">
                    Wait time
                  </p>
                  <p className="mt-3 text-3xl font-black tracking-tight text-[#1C1C1C]" data-id="element-316" data-mp="189oj8erv3bt2">
                    Avg Wait: 14m
                  </p>
                </div>
                <Clock3Icon className="h-5 w-5 text-[#B46423]" data-id="element-317" data-mp="3sznpmjt9dctk" />
              </div>
              <div className="mt-5 flex h-16 items-end gap-2" aria-label="Wait time peaks at 5pm" data-id="element-318" data-mp="3ny6rux62m6h7">
                {peakWaitData.map(item => <div key={item.label} className="flex flex-1 flex-col items-center gap-1" data-id="element-319" data-mp="28h3gv4qmrhmp">
                    <div className="w-full bg-[#D68745]" style={{
                  height: `${item.value}%`
                }} data-id="element-320" data-mp="2h8c4plf27e6x" />
                    <span className="text-[10px] text-[#777]" data-id="element-321" data-mp="2r6jmg6h6a09z">
                      {item.label}
                    </span>
                  </div>)}
              </div>
            </article>
            <article className="rounded-lg border border-gray-100 bg-white p-5" data-id="element-322" data-mp="306y5ez6nz3ab">
              <div className="flex items-start justify-between" data-id="element-323" data-mp="304vfsg9fbc64">
                <div data-id="element-324" data-mp="11t6co1qajk1h">
                  <p className="text-xs font-bold uppercase tracking-[0.12em] text-[#008F82]" data-id="element-325" data-mp="11tod7ajzkkf7">
                    Empathetic care
                  </p>
                  <p className="mt-3 text-4xl font-black tracking-tight text-[#1C1C1C]" data-id="element-326" data-mp="2955p4n9l081u">
                    4.7{' '}
                    <span className="text-lg font-bold text-[#777]" data-id="element-327" data-mp="246kmyiarrear">/ 5</span>
                  </p>
                </div>
                <MessageSquareTextIcon className="h-5 w-5 text-[#008F82]" data-id="element-328" data-mp="2i2of86231ckl" />
              </div>
              <p className="mt-5 text-sm text-[#555]" data-id="element-329" data-mp="2e5a76hq51au6">
                93% mention clear, respectful support.
              </p>
              <button type="button" onClick={() => setSelectedReview(true)} className="mt-3 text-sm font-bold text-[#008F82] underline underline-offset-4" data-id="element-330" data-mp="2n3vpcbrp6nuf">
                Read feedback
              </button>
            </article>
          </div>
          <div className="mt-5 grid gap-5 xl:grid-cols-[1.1fr_.9fr]" data-id="element-331" data-mp="3at6nrmlks65e">
            <section className="border border-[#D7E2D9] bg-white" data-id="element-332" data-mp="3ar3qqim09cr6">
              <div className="flex items-center justify-between border-b border-[#E5E5E5] p-5" data-id="element-333" data-mp="35vohy52uu71m">
                <div data-id="element-334" data-mp="3phgi7f6204a6">
                  <h2 className="font-black text-[#1C1C1C]" data-id="element-335" data-mp="3pe2g881axx39">
                    Bottlenecks to act on
                  </h2>
                  <p className="mt-1 text-xs text-[#777]" data-id="element-336" data-mp="3gfgy2dzqsk30">
                    Signals need an operational response.
                  </p>
                </div>
                <TriangleAlertIcon className="h-5 w-5 text-[#B46423]" data-id="element-337" data-mp="3kfhh6bxsdjge" />
              </div>
              <div className="divide-y divide-[#E5E5E5]" data-id="element-338" data-mp="36o2vfxchv45n">
                <div className="p-5" data-id="element-339" data-mp="3bgvzej0528go">
                  <div className="flex items-start justify-between gap-4" data-id="element-340" data-mp="3bhyp4nlq64v0">
                    <div data-id="element-341" data-mp="2ws9cnw86meff">
                      <p className="font-bold text-[#1C1C1C]" data-id="element-342" data-mp="2wt2kz1mshbzo">
                        Afternoon queue rising after 4 PM
                      </p>
                      <p className="mt-1 text-sm text-[#666]" data-id="element-343" data-mp="2nr1poab4900n">
                        Wait reports are 22% above your weekly baseline.
                      </p>
                    </div>
                    <span className="shrink-0 bg-[#FCF1E8] px-2 py-1 text-xs font-bold text-[#B46423]" data-id="element-344" data-mp="387w22zj70ygv">
                      High
                    </span>
                  </div>
                  <button type="button" className="mt-3 text-sm font-bold text-[#008F82] underline underline-offset-4" data-id="element-345" data-mp="336q70v228z46">
                    View staffing prompt
                  </button>
                </div>
                <div className="p-5" data-id="element-346" data-mp="2p9tl980su7u5">
                  <p className="font-bold text-[#1C1C1C]" data-id="element-347" data-mp="2paux3epn2ycx">
                    Three insulin refill questions this week
                  </p>
                  <p className="mt-1 text-sm text-[#666]" data-id="element-348" data-mp="2figu6imtrlp6">
                    Review substitutions and patient call-back protocol.
                  </p>
                </div>
              </div>
            </section>
            <section className="border border-[#D7E2D9] bg-white p-5" data-id="element-349" data-mp="26h8upx8koeti">
              <p className="text-xs font-bold uppercase tracking-[0.12em] text-[#008F82]" data-id="element-350" data-mp="21ixm1pu0kacv">
                Community review management
              </p>
              <h2 className="mt-2 font-black text-[#1C1C1C]" data-id="element-351" data-mp="h153f627rkow">
                “Staff remembered my name…”
              </h2>
              <p className="mt-3 text-sm leading-6 text-[#555]" data-id="element-352" data-mp="q23c41nlkgdt">
                Praise is showing up consistently in care feedback. Share this
                with the team at huddle.
              </p>
              <div className="mt-5 flex gap-2" data-id="element-353" data-mp="3ugb6s5nf238j">
                <button type="button" onClick={() => setSelectedReview(!selectedReview)} className="bg-[#008F82] px-3 py-2 text-sm font-bold text-white hover:bg-[#006F65] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#008F82] focus-visible:ring-offset-2" data-id="element-354" data-mp="3uhmfmjvpy16i">
                  {selectedReview ? 'Marked reviewed' : 'Mark reviewed'}
                </button>
                <button type="button" className="border border-[#C8D6CC] px-3 py-2 text-sm font-bold text-[#008F82] hover:bg-[#F4F7F4]" data-id="element-355" data-mp="3frf30kse7cdq">
                  Share with team
                </button>
              </div>
            </section>
          </div>
        </section>
      </div>
    </main>;
}